class LocalizationFm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.button.setAttribute(
      "aria-expanded",
      (
        this.elements.button.getAttribute("aria-expanded") === "false"
      ).toString()
    );
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-fm", LocalizationFm);

// Search ------------------------

const searchInput = document.getElementById("countrySearch");
const countryItems = document.querySelectorAll("#CountryList li");
const searchResultCount = document.getElementById("searchResultCount");
const arrowUp = document.getElementById("arrowUp");
const arrowDown = document.getElementById("arrowDown");

let currentIndex = 0;
let matchingItems = [];

// Event listener for typing in the input field
searchInput.addEventListener("input", function () {
  const searchQuery = this.value.toLowerCase();

  if (searchQuery.length >= 3) {
    // Find matching countries or currencies
    matchingItems = Array.from(countryItems).filter(function (item) {
      const countryName = item.querySelector("p").innerText.toLowerCase();
      return countryName.includes(searchQuery);
    });

    // Show the count of results like "1 of 3"
    if (matchingItems.length > 0) {
      searchResultCount.innerHTML = `1 of ${matchingItems.length}`;
      highlightItem(0); // Highlight the first result
    } else {
      searchResultCount.innerHTML = "No matches found";
    }
  } else {
    searchResultCount.innerHTML = ""; // Clear result count if query is too short
    matchingItems.forEach((item) => (item.style.backgroundColor = "")); // Clear highlights
  }
});

// Click event listener for the down arrow

// Click event listener for the up arrow

// Function to highlight and scroll to the current item
function highlightItem(index) {
  // Remove previous highlights
  matchingItems.forEach((item) => (item.style.backgroundColor = ""));

  // Highlight the current item and scroll it into view
  const currentItem = matchingItems[index];
  currentItem.style.backgroundColor = "#ffff99";
  currentItem.scrollIntoView({ behavior: "smooth", block: "center" });

  // Update the display to show the current result (e.g., "2 of 3")
  searchResultCount.innerHTML = `${index + 1} of ${matchingItems.length}`;
}

// country list -------

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("countrySearch");
  const countryList = document.getElementById("CountryList");
  const countryItems = countryList.querySelectorAll(".dicsl");

  searchInput.addEventListener("input", function () {
    const searchValue = this.value.toLowerCase().trim();

    // If search is empty, show all items
    if (searchValue === "") {
      countryItems.forEach((item) => {
        item.style.display = "flex";
      });
      return;
    }

    countryItems.forEach((item) => {
      // Get text content from both the country name and currency info
      const countryLink = item.querySelector("a:last-child");
      const countryText = countryLink.textContent.toLowerCase();

      // Show item if it matches the search value
      if (countryText.includes(searchValue)) {
        item.style.display = "flex";
      } else {
        item.style.display = "none";
      }
    });
  });

  // Focus on search input when the dropdown is opened
  const toggleButton = document.getElementById("selectmarket");
  toggleButton.addEventListener("click", function () {
    setTimeout(() => searchInput.focus(), 100);
  });
});

document
  .getElementById("language_selector")
  .addEventListener("click", function () {
    var mp1 = document.getElementById("mp2");
    mp1.classList.add("visible");
  });

document.addEventListener("click", function (event) {
  if (
    event.target.classList.contains("close_mp2") ||
    event.target.classList.contains("close_mp2_button") ||
    event.target.classList.contains("mp2")
  ) {
    var mp1 = document.getElementById("mp2");
    mp1.classList.remove("visible");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const button2 = document.querySelector(".trigger_button_2");
  const countryList2 = document.getElementById("LanguageList");

  button2.addEventListener("click", function () {
    if (
      countryList2.style.display === "none" ||
      countryList2.style.display === ""
    ) {
      countryList2.style.display = "block";
    } else {
      countryList2.style.display = "none";
    }
  });

  const button = document.querySelector('.trigger_button_1');
  const countryList = document.getElementById('CountryList');

  button.addEventListener('click', function() {
    if (countryList.style.display === 'none' || countryList.style.display === '') {
      countryList.style.display = 'block';
    } else {
      countryList.style.display = 'none';
    }
  });
});